import cn from "classnames";
import { Link } from "react-router-dom";
import ErrorPage from "@/modules/main/ErrorPage/ErrorPage";
import { ICommonErrorPage } from "@/modules/main/Forbidden/Forbidden";
import buttonStyle from "@/ui-components/commonComponents/Button/style.module.css";

export default function ServerFail({ isSignedIn, isAdmin, isClient }: ICommonErrorPage) {
  return (
    <ErrorPage
      isSignedIn={isSignedIn}
      isAdmin={isAdmin}
      isClient={isClient}
      errorReason={"Sorry, this page is not working now. Please, refresh it in a few minutes."}
    >
      <Link to="/" className={cn(buttonStyle.linkAsButton, buttonStyle.linkAsButtonPrimary)}>
        go back
      </Link>
    </ErrorPage>
  );
}
